import { ReactNode } from "react";
import { create } from 'zustand';

export interface Alert {
  title?: string;
  message: string | ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  isHTML?: boolean;
}

interface AlertState {
  alert: Alert | null;
  setAlert: (newAlert: Alert) => void;
  clearAlert: () => void;
}

export const alertStore = create<AlertState>((set) => ({
  alert: null,
  setAlert: (newAlert) => set({ alert: newAlert }),
  clearAlert: () => set({ alert: null }),
}));
